import { addons } from '@storybook/manager-api';

import CNSATheme from './cnsa-theme';

addons.setConfig({
  theme: CNSATheme,
});
